import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'

import './Pagination.scss'

class Pagination extends PureComponent {
  constructor (props, context) {
    super(props, context)
    this.renderPreviousLink = this.renderPreviousLink.bind(this)
    this.renderNextLink = this.renderNextLink.bind(this)
  }

  renderPreviousLink (prevStoreIndex) {
    if (prevStoreIndex < 0) return <span />

    const previousLink = this.props.stores[prevStoreIndex].permalink
    const prevStore = this.props.stores[prevStoreIndex]
    return (
      <Link
        to={previousLink}
        className={'pag-btn pag-btn-prev'}
        onClick={(event) => this.props.getStoreCallback(event, prevStore.id, prevStoreIndex, prevStore)}>
        <span className='argos-icon icon-UIE-Controls-Chevron-Left' aria-hidden='true' />
        <span className='pag-btn-prev--text'>Prev store</span>
      </Link>
    )
  }

  renderNextLink (nextStoreIndex) {
    if (nextStoreIndex >= this.props.stores.length) return <span />

    const nextLink = this.props.stores[nextStoreIndex].permalink
    const nextStore = this.props.stores[nextStoreIndex]
    return (
      <Link
        to={nextLink}
        className={'pag-btn pag-btn-next'}
        onClick={(event) => this.props.getStoreCallback(event, nextStore.id, nextStoreIndex, nextStore)}>
        <span className='pag-btn-prev--text'>Next store</span>
        <span className='argos-icon icon-UIE-Controls-Chevron-Right' aria-hidden='true' />
      </Link>
    )
  }

  render () {
    if (this.props.currentStoreIndex === null) return null
    const currentStoreIndex = this.props.currentStoreIndex
    const prevStoreIndex = parseInt(currentStoreIndex - 1)
    const nextStoreIndex = parseInt(currentStoreIndex + 1)
    return (
      <div className='pagination'>
        {this.renderPreviousLink(prevStoreIndex)}
        {this.renderNextLink(nextStoreIndex)}
      </div>
    )
  }
}

Pagination.propTypes = {
  stores: PropTypes.array,
  currentStoreIndex: PropTypes.number,
  getStoreCallback: PropTypes.func
}

export default Pagination



// WEBPACK FOOTER //
// ./src/components/Pagination/Pagination.jsx